<template>
  <div class="basic-container">
    <!-- 搜索区域 -->

    <el-card class="box-card area-card">
      <el-collapse-transition>
        <div v-if="collapseSearchArea">
          <div class="area-search">
            <div class="area-form">
              <el-form
                ref="searchForm"
                :label-width="labelWidth"
                label-position="left"
              >
                <el-row :gutter="20">
                  <el-col
                    v-for="s in searchList"
                    :key="s.id"
                    class="form-group"
                    :lg="6"
                    :sm="12"
                    :xs="24"
                  >
                    <el-form-item :label="s.label + ':'">
                      <el-input
                        style="width: 90%"
                        v-if="s.type === 'input'"
                        v-model="s.value"
                        @input="inputMethod"
                        @focus="focusIndex(s.label)"
                        :placeholder="s.placeholder"
                        clearable
                      ></el-input>
                      <el-select
                        style="width: 90%"
                        v-if="s.type === 'select'"
                        v-model="s.value"
                        :placeholder="s.placeholder"
                        clearable
                      >
                        <el-option
                          style="width: 90%"
                          v-for="i in s.options"
                          :key="i.value"
                          :label="i.label ? i.label : i"
                          :value="i.value ? i.value : i"
                        >
                        </el-option>
                      </el-select>
                      <el-select
                        v-if="s.type === 'remote'"
                        v-model="s.value"
                        filterable
                        clearable
                        remote
                        ref="select"
                        @hook:mounted="cancalReadOnly"
                        @visible-change="cancalReadOnly"
                        reserve-keyword
                        :placeholder="s.placeholder"
                        :remote-method="remoteMethod"
                        :loading="s.loading"
                        @focus="focusRemote(s.label)"
                      >
                        <el-option
                          style="width: 90%"
                          v-for="i in s.options"
                          :key="i.id || i.value"
                          :label="i.label"
                          :value="i.value"
                        >
                        </el-option>
                      </el-select>
                      <el-date-picker
                        clearable
                        style="width: 90%"
                        v-if="s.type === 'date'"
                        v-model="s.value"
                        type="daterange"
                        align="center"
                        unlink-panels
                        range-separator="—"
                        start-placeholder="起始日"
                        end-placeholder="截止日"
                        :picker-options="pickerOptions"
                      >
                      </el-date-picker>
                      <el-date-picker
                        v-if="s.type === 'datetime'"
                        style="width: 90%"
                        v-model="s.value"
                        type="datetimerange"
                        :picker-options="pickerOptions"
                        range-separator="-"
                        start-placeholder="起始日"
                        end-placeholder="截止日"
                        align="center"
                      >
                      </el-date-picker>
                      <el-cascader
                        v-if="s.type === 'cascade'"
                        :options="s.options"
                        v-model="s.value"
                        :placeholder="s.placeholder"
                        :props="{
                          multiple: true,
                          checkStrictly: true,
                          value: 'catId',
                          label: 'name',
                        }"
                        clearable
                      ></el-cascader>
                    </el-form-item>
                  </el-col>
                  <el-col
                    class="form-group block"
                    v-for="i in offsetNum"
                    :key="`${i}key`"
                    :lg="6"
                    :sm="12"
                    :xs="24"
                  ></el-col>
                  <el-col
                    class="form-group search-btn"
                    :lg="6"
                    :sm="12"
                    :xs="24"
                  >
                    <el-button
                      type="primary"
                      icon="el-icon-search"
                      @click="handleSearch"
                      >查 询</el-button
                    >
                    <el-button
                      type="default"
                      icon="el-icon-delete"
                      @click="handleClear"
                      style="margin-right: 8%"
                      >重 置</el-button
                    >
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </div>
      </el-collapse-transition>
      <div class="area-menu">
        <!-- 左边按钮区域 -->
        <div class="area-left">
          <span class="area-left-text">已选中 {{ selectedcount }} 项</span>
        </div>
        <!-- 右边按钮区域 -->
        <div class="area-right">
          <span v-for="(tb) in tableButtonList" :key="tb.id">
            <!-- :type="tb.label == '清空' ? 'default' : 'primary'" -->
            <!--  :class="[tindex == 0 ? '' : 'm-l-10']" -->
            <el-button
              v-if="tb.permissions || false"
              style="margin-left: 10px;"
              :icon="tb.icon"
              :plain="tb.label == '导出' ? true : false"
              @click="handleTable(tb)"
              >{{ tb.label }}</el-button
            >
          </span>
          <span style="margin-left: 10px">
            <slot name="tabelButton" />
          </span>
          <span>
            <!-- style="margin-left: 10px" -->
            <!-- <el-button v-if="sys_view_setting" @click="handleViewSetting">
              视图设置
            </el-button> -->
          </span>
        </div>
      </div>
      <!-- 列表区域 -->
      <!--  :height="!columnStyle.length ? 300 : ''" -->
      <div v-if="JSON.stringify(tabsObject) !== '{}'">
        <el-tabs
          :style="
            'width:' + tabsObject.list.length * 80 + 'px;margin-left:24px'
          "
          v-model="tabsObject.value"
          @tab-click="tabsChange"
        >
          <el-tab-pane
            v-for="t in tabsObject.list"
            :key="t.id"
            :label="t.label"
            :name="t.name"
          ></el-tab-pane>
        </el-tabs>
      </div>
      <el-table
        v-if="columnStyle.length"
        :max-height="tableStyle.maxHeight || 'none'"
        :v-loading="loading"
        :data="tableData"
        :stripe="tableStyle.isStripe == 1 ? true : false"
        :border="tableStyle.isBorder == 1 ? true : false"
        :cell-style="{ 'text-align': tableStyle.cellStyle || 'center' }"
        :header-cell-style="{
          'text-align': tableStyle.headerStyle || 'center',
          'line-height': tableStyle.headerHeight + 'px',
          color: '#000',
        }"
        :header-row-style="{
          'line-height': tableStyle.headerHeight + 'px',
          'box-sizing': 'border-box',
        }"
        @selection-change="handleSelectionChange"
      >
        <!-- 是否多选 -->
        <el-table-column
          v-if="tableStyle.isSelection"
          type="selection"
          width="55"
        >
        </el-table-column>
        <!-- 是否索引 -->
        <el-table-column v-if="tableStyle.isIndex" label="序号" type="index">
        </el-table-column>
        <!-- 循环列表 -->
        <template v-for="c in columnStyle">
          <el-table-column
            :render-header="tableStyle.columnWidth || c.width || headSpanFit"
            :width="tableStyle.columnWidth || c.width || ''"
            :min-width="tableStyle.columnWidth || c.width || ''"
            :key="c.id"
            :label="c.label"
            :sortable="c.isSortable == 1 ? true : false"
            show-overflow-tooltip
            v-if="c.isShow == 1"
            :prop="c.prop"
            fit
          >
            <template slot-scope="scope">
              <span
                v-if="
                  Array.isArray(scope.row[c.prop]) && scope.row[c.prop].length
                "
              >
                <span v-for="(m, index) in scope.row[c.prop]" :key="index"
                  >{{ m.materialName || m.goodName }}
                  {{ index + 1 === scope.row[c.prop].length ? "" : "；" }}</span
                >
              </span>
              <span
                v-else-if="
                  Object.prototype.toString.call(scope.row[c.prop]) ===
                  '[object Object]'
                "
              >
                <span
                  v-for="(value, key, index) in scope.row[c.prop]"
                  :key="key"
                >
                  {{ key | nutFilter }}：{{ value || "待完善"
                  }}{{
                    index + 1 === Object.keys(scope.row[c.prop]).length
                      ? ""
                      : "；"
                  }}
                </span>
              </span>
              <span v-else-if="/^\d{13}$/.test(scope.row[c.prop])">
                {{ toDate(scope.row[c.prop]) }}
              </span>
              <span v-else>
                <div v-if="valiImgType(scope.row[c.prop]) && scope.row[c.prop]">
                  <el-popover
                    popper-class="popperStyle"
                    placement="top-start"
                    trigger="hover"
                  >
                    <img :src="scope.row[c.prop]" />
                    <span slot="reference" class="text-theme">查看图片</span>
                  </el-popover>
                </div>
                <div v-else>
                  <span>{{ scope.row[c.prop] }}</span>
                </div>
              </span>
            </template>
          </el-table-column>
        </template>
        <!-- 操作按钮 -->
        <el-table-column
          label="操作"
          fixed="right"
          :width="optionAreaWidth + 'px'"
          v-if="isOption"
        >
          <!-- width="240" -->
          <!-- permissions -->
          <template slot-scope="scope">
            <span v-for="(b, bindex) in optionButtonList" :key="b.id">
              <el-button
                :class="[bindex === 0 ? '' : 'm-l-10']"
                v-if="b.permissions || false"
                type="text"
                :icon="b.icon"
                @click="handleOption(b.label, scope.row)"
                >{{ b.label }}</el-button
              >
            </span>
            <slot name="options"></slot>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <div class="area-pagination" v-if="!notPaging">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-sizes="[10, 20, 30, 40, 50, 100]"
          :page-size="pagination.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { dateFormat } from "@/util/date.js";
import { debounce } from "@/util/tool.js";
import { mapGetters } from "vuex";
import "../../styles/theme/common-list.scss";
import nutFilter from "@/util/filters.js";
export default {
  name: "commonList",
  inject: ["reload"],
  data() {
    return {
      // 右边搜索按钮折叠搜索区域
      collapseSearchArea: true,

      // 时间段筛选快捷
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      time: "",
      offsetNum: 0,

      selectedcount: 0,

      sys_view_setting: "",

      splitArr: [],
      count: 0,

      labelWidth: "",
    };
  },
  props: {
    // 表格加载动画
    loading: {
      type: Boolean,
    },
    //tab下标
    TabIndex: {
      type: [Number, String],
    },
    // 表格假数据
    tableData: {
      type: Array,
    },
    // 搜索列表
    searchList: {
      type: Array,
    },
    // 表格整体样式
    tableStyle: {
      type: Object,
    },
    // 列样式
    columnStyle: {
      type: Array,
    },
    // 整表按钮区域
    tableButtonList: {
      type: Array,
    },
    // 操作按钮区域
    optionButtonList: {
      type: Array,
    },
    // 分页区域
    pagination: {
      type: Object,
    },
    // 是否不显示分页区域
    notPaging: {
      type: Boolean,
      default: false,
    },
    // 操作区宽度
    optionAreaWidth: {
      type: [Number, String],
      default: 200,
    },
    // 是否显示表格操作区域
    isOption: {
      type: Boolean,
      default: true,
    },
    // 是否显示表格 tabs 组件
    tabsObject: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  computed: {
    ...mapGetters(["permissions"]),
  },
  created() {
    this.sys_view_setting = this.permissions["sys_view_setting"];
  },

  mounted() {
    this.setLabelWidth();
    setTimeout(() => {
      const num =
        this.searchList.length % 4 === 0 ? 0 : this.searchList.length % 4;
      this.offsetNum = 3 - num;
      // console.log("当前移动", num, this.offsetNum);
      // this.getSearchSplit();
    }, 1000);
  },
  updated() {
    this.setLabelWidth();
  },
  beforeUpdate() {
    clearTimeout(this.time);
  },

  methods: {
    setLabelWidth() {
      let len = 0;
      for (const i of this.searchList) {
        if (i.label) {
          i.label.length > len && (len = i.label.length);
        }
      }
      this.labelWidth = len * 18 + "px";
    },

    /**
     * tabs 页切换
     */
    tabsChange(e) {
      this.$emit("handleTabsChange", e);
    },

    /**
     * 将筛选区域数组拆分成多个数组
     */
    getSearchSplit() {
      for (let i = 0; i < this.searchList.length / 4; i++) {
        this.splitArr[i] = [];
      }
      this.recursionSplitArr(this.searchList);
      // console.log("=========== 搜索区域列表 ============");
      // console.log(this.splitArr);
      this.$forceUpdate();
    },

    /**
     * 递归拆分数组
     */
    recursionSplitArr(arr) {
      // console.log("数组个数", this.count);
      // console.log("进入方法的数组====>");
      // console.log(arr);
      // console.log("进入方法的数组的数量====>", arr.length);
      let surplusArr = [];
      if (arr.length > 4) {
        arr.forEach((ele, index) => {
          if (index < 4) {
            this.splitArr[this.count].push(ele);
          } else {
            // if (!surplusArr.length) return;
            surplusArr = arr.slice(4);
            // console.log("剩余数组======>");
            // console.log(surplusArr);
            this.count++;
            this.recursionSplitArr(surplusArr);
          }
        });
      } else {
        if (!Array.isArray(this.splitArr[this.count])) {
          this.splitArr[this.count] = [];
        }

        for (let j = 0; j < arr.length; j++) {
          const element = arr[j];
          this.splitArr[this.count].push(element);
        }

        this.splitArr[this.count].concat(arr);
        for (let i = 0; i < this.offsetNum; i++) {
          this.splitArr[this.count].push({});
        }
        return;
      }
    },

    /**
     * 视图按钮设置
     */
    handleViewSetting() {
      this.$message.warning("该功能暂未开发");
    },

    // /**
    //  * 刷新按钮
    //  */
    // handleRefresh() {
    //   this.reload();
    // },

    // /**
    //  * 折叠搜索按钮
    //  */
    // handleCollapseSearchArea() {
    //   console.log("调用了");
    //   this.collapseSearchArea = !this.collapseSearchArea;
    // },

    /**
     * 远程搜索
     */
    //搜索框
    remoteMethod(v) {
      // console.log(v);
      this.$emit("handleRemoteMethod", v);
    },
    //input框
    inputMethod: debounce(function (v) {
      console.log(v);
      this.$emit("handleInputMethod", v[0]);
    }, 500),

    cancalReadOnly(value) {
      this.$nextTick(() => {
        if (!value) {
          const { select } = this.$refs;
          select.forEach((item) => {
            let inp = item.$el.querySelector(".el-input__inner");
            inp.removeAttribute("readonly");
          });
        }
      });
    },

    /**
     * 选中的远程搜索框
     */
    focusRemote(v) {
      this.$emit("handleFocusRemote", v);
    },
    focusIndex(v) {
      this.$emit("handleFocusIndex", v);
    },

    /**
     * 折叠搜索按钮
     */
    handleCollapseSearchArea() {
      this.collapseSearchArea = !this.collapseSearchArea;
    },

    /**
     * 验证上传图片格式
     */
    valiImgType(str) {
      if (!/\.(gif|jpg|jpeg|png|GIF|JPG|JPEG|PNG)$/.test(str)) return false;
      else return true;
    },
    /**
     * 搜索按钮
     */
    handleSearch() {
      this.$emit("handleContentSearch", this.searchList);
    },

    /**
     * 清空按钮
     */
    handleClear() {
      this.$emit("handleClearSearch", this.searchList);
    },

    /**
     * 根据表头列宽设置整列宽度
     */
    headSpanFit(h, { column, index }) {
      let labelLong = column.label.length; // 表头label长度
      let size = 16; // 根据需要定义标尺，直接使用字体大小确定就行，也可以根据需要定义
      column.minWidth = labelLong * size + 40; // 根据label长度计算该表头最终宽度
      return h("span", { class: "cell-content", style: { width: "100%" } }, [
        column.label,
      ]);
    },

    /**
     * 点击整表按钮
     */
    handleTable(val) {
      this.$emit("handleTable", val);
    },

    /**
     * 点击操作按钮
     */
    handleOption(param, row) {
      this.$emit("handleOption", { param, row });
    },

    /**
     * 选择项发生改变时候
     */
    handleSelectionChange(selection) {
      this.selectedcount = selection.length;
      this.$emit("handleSelectionChange", selection);
    },

    /**
     * 分页
     */
    handleSizeChange(val) {
      this.$emit("handleSizeChange", val);
    },
    handleCurrentChange(val) {
      this.$emit("handleCurrentChange", val);
    },

    /**
     * 时间戳转换日期
     */
    toDate(value) {
      if (value) {
        return dateFormat(value);
      } else {
        return;
      }
    },
  },
};
</script>

<style lang="scss">
.el-row {
  display: flex;
  flex-wrap: wrap;
}
.m-l-10 {
  margin-left: 10px;
}
.form-group {
  &.block {
    height: 50px;
  }
  &.search-btn {
    display: flex;
    align-items: center;
    justify-content: right;
  }
  .el-form-item {
    width: 100%;
    .el-select {
      width: 90%;
    }
    .el-cascader {
      width: 90%;
    }
    .el-input {
      width: 90% !important;
    }
  }
}
</style>
